import { clomp } from 'clomp';

export const Base = clomp.div`
  animate-spin
  border-4
  inline-block
  rounded-full
  spinner-border
`;
